module.exports = __webpack_public_path__ + "img/cyborg-face.b3621baa.svg";